import { render, staticRenderFns } from "./ModalDeletePolicy.vue?vue&type=template&id=a23f3ca0&"
import script from "./ModalDeletePolicy.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports